import './Card2.css'

const Card2 = () => {
  return (
    <>
    <div className='title_con2'>
      <div className='title_card2'>
        Våra Lokaler
      </div>
    </div>
    <div className='grid-container_event'>
        <div className='card_con'>
            <div className='wrapper_event'>
                <div className='card_area'>
                    <div className='card'>
                        <a id="image" href="#image"><img class="cssbox_thumb" src="" />
                            <span class="cssbox_full"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image1" href="#image1"><img class="cssbox_thumb1" src="" />
                            <span class="cssbox_full1"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image2" href="#image2"><img class="cssbox_thumb2" src="" />
                            <span class="cssbox_full2"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image3" href="#image3"><img class="cssbox_thumb3" src="" />
                            <span class="cssbox_full3"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image4" href="#image4"><img class="cssbox_thumb4" src="" />
                            <span class="cssbox_full4"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image5" href="#image5"><img class="cssbox_thumb5" src="" />
                            <span class="cssbox_full5"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image6" href="#image6"><img class="cssbox_thumb6" src="" />
                            <span class="cssbox_full6"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image7" href="#image7"><img class="cssbox_thumb7" src="" />
                            <span class="cssbox_full7"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image8" href="#image8"><img class="cssbox_thumb8" src="" />
                            <span class="cssbox_full8"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="image9" href="#image9"><img class="cssbox_thumb9" src="" />
                            <span class="cssbox_full9"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default Card2